<!--每个card的操作栏-->
<template>
  <Dropdown
    @on-click="clickItem"
    class="dropitem-container"
    placement="bottom-end"
  >
    <i class="iconfont icon-newicon-gengduo more-icon"></i>
    <DropdownMenu slot="list">
      <!--配置功能-->
      <DropdownItem v-if="itemType == 0" name="config">
        <i class="iconfont icon-newicon-peizhi"></i>
        {{ $t('common.config') }}
      </DropdownItem>
      <!--移除模块功能-->
      <DropdownItem v-if="itemType == 1" name="remove">
        <i class="iconfont icon-newicon-yichu"></i>
        {{ $t('common.remove') }}
      </DropdownItem>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
import api from '../../../api/home/index';
export default {
  props: {
    itemType: {
      require: true,
      type: Number,
    },
    itemData: {
      require: true,
      type: Object,
    },
    modules: {
      require: true,
      type: Array,
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    clickItem(name) {
      switch (name) {
        case 'remove':
          this.removeCard();
          break;
      }
    },
    removeCard() {
      //此删除方法其实就是通过重新保存剩下的需要的模块来达到删除的效果
      let tagIds = '';
      this.modules.map(tag => {
        if (tag.id !== this.itemData.id) {
          //过滤掉当前要删除的
          tagIds += tag.id + ',';
        }
      });
      tagIds = tagIds.substring(0, tagIds.length - 1); //去掉最后一个逗号
      if (tagIds.length === 0) {
        this.$Message.error(this.$t('home.card_config_notnullerror'));
        return;
      }
      api
        .saveUserShopTags({
          tagIds: tagIds,
        })
        .then(() => {
          this.$Message.success(this.$t('home.success_remove'));
          this.$emit('refresh');
        })
        .catch(error => {
          this.$Message.error(`${this.$t('home.error_remove')}:${error}`);
        });
    },
  },
};
</script>
<style lang="scss" type="text/scss">
.dropitem-container {
  .ivu-dropdown-menu {
    min-width: 20px;
    .ivu-dropdown-item {
      padding: 7px 10px;
    }
  }
}
</style>
